import { Box, Text } from '@domain-group/suit-theme'

import Tag from './Tag'

type TagContainerProps = {
  height: number,
  tags: object[],
  width: number,
}

const TagContainer = (props: TagContainerProps) => {
  const {
    height,
    tags,
    width,
  } = props

  return (
    <Box
      height={height}
      position="relative"
      width={width}
      zIndex={1}
    >
      {tags.map((tag, index) => (
        // @ts-expect-error TS2339
        <Tag index={index} key={tag.id} tag={tag} />
      ))}
    </Box>
  )
}

export default TagContainer
